import LearnVisualFrame from "./LearnVisualFrame";
import p from "./visualPalette";

export default function LassondeCurveVisual({ title, takeaway, caption }) {
  return (
    <LearnVisualFrame title={title} takeaway={takeaway} caption={caption} size="large">
      <svg viewBox="0 0 840 450" role="img" aria-label="Conceptual Lassonde Curve showing expectations rising during discovery, changing through resource definition and development, and shifting toward operating performance in production.">
        <line x1="82" y1="340" x2="780" y2="340" stroke={p.ink} strokeWidth="2" />
        <path d="M780 340 l-12 -7 v14 z" fill={p.ink} />
        <line x1="82" y1="340" x2="82" y2="62" stroke={p.ink} strokeWidth="2" />
        <path d="M82 62 l-7 12 h14 z" fill={p.ink} />
        <text x="42" y="220" fontSize="12" fontWeight="850" fill={p.muted} transform="rotate(-90 42 220)">Market expectations</text>

        <path
          d="M82 318 C145 312 168 248 206 210 C240 176 256 96 304 88 C358 80 382 186 424 214 C470 244 526 240 572 260 C636 288 672 318 780 304"
          fill="none"
          stroke={p.gold}
          strokeWidth="4"
          strokeLinecap="round"
        />

        {[
          ["Exploration", 132, "Speculation"],
          ["Discovery", 292, "Expectations"],
          ["Resource", 430, "Definition"],
          ["Development", 574, "De-risking"],
          ["Production", 724, "Cash flow"],
        ].map(([stage, x, label]) => (
          <g key={stage}>
            <line x1={x} y1="340" x2={x} y2="352" stroke={p.ink} strokeWidth="1.5" />
            <text x={x} y="374" textAnchor="middle" fontSize="12" fontWeight="850" fill={p.ink}>{stage}</text>
            <foreignObject x={x - 58} y="386" width="116" height="34">
              <div xmlns="http://www.w3.org/1999/xhtml" style={{ fontSize: 11.5, lineHeight: 1.25, color: p.muted, textAlign: "center", fontWeight: 750 }}>
                {label}
              </div>
            </foreignObject>
          </g>
        ))}

        <text x="304" y="66" textAnchor="middle" fontSize="13" fontWeight="900" fill={p.ink}>Discovery enthusiasm</text>
        <path d="M304 72 V86" stroke={p.softLine} strokeWidth="1.5" />
      </svg>
    </LearnVisualFrame>
  );
}
